import { dataHooks } from '@wix/data-hooks';

export const fulfillmentPickerDataHooks = dataHooks<{
  root: {};
  option: { type: string };
}>('fulfillment-picker');
